import React, { useEffect } from 'react';

import { useQuery } from '@apollo/client/react';
import { useNavigate } from 'react-router';
import { MainView } from '@repo/ui/Views';

import DIDS_SHOW_Q from '../gql/show.gql';
import DidTabNav from '../components/DidTabNav';
import { useParams } from 'react-router';
// import SendManualSms from '../components/SendManualSms';

const DidSendManualMessage = () => {
  const params = useParams();
  const didId = params.didId;

  const navigate = useNavigate();

  useEffect(() => {
    navigate('/');
  }, [navigate]);

  const { loading, error, data } = useQuery(DIDS_SHOW_Q, {
    variables: {
      id: String(didId),
    },
  });

  console.error(error);

  return (
    <MainView title={loading ? `Loading...` : `${data?.did?.number}`} loading={loading}>
      <DidTabNav />
      {/* {data?.did?.number ? <SendManualSms number={data.did.number} /> : null} */}
    </MainView>
  );
};

export default DidSendManualMessage;
